import { Grid, Toolbar } from "@mui/material";
import Cookies from "js-cookie";
import { useRouter } from "next/router";
import { Fragment, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect, useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { bindActionCreators } from "redux";
import { fetchRecentSearches, getItem } from "../../../helpers/data_management";
import {
  updateCurrentSalaryDialog,
  updateProfilePreviewDialog,
} from "../../../redux/actions/dialog_action";
import {
  updateShowSignInModalStatus,
  updateSignInModalSignUpStatus,
  updateSignInText,
  updateSignUpText,
} from "../../../redux/actions/navbar_action";
import {
  checkAuthentication,
  getUser,
} from "../../../redux/actions/user_action";
import { store } from "../../../redux/stores/store";
import SharedDownloadAppBanner from "../../shared/SharedDownloadAppBanner/SharedDownloadAppBanner";
import SharedNavbar2 from "../../shared/SharedNavbar/Navbar/Navbar";
import HomepageAds from "../HomepageAds/HomepageAds";
import HomepageDiscoverCompanies from "../HomepageDiscoverCompanies/HomepageDiscoverCompanies";
import HomepageReplaceResumeDialog from "../HomepageReplaceResumeDialog/HomepageReplaceResumeDialog";
import HomepageResumeUploadedDialog from "../HomepageResumeUploadedDialog/HomepageResumeUploadedDialog";
import { useHomepageResumeUploadState } from "../HomepageResumeUploadContext";
import HomepageSearch from "../HomepageSearch/HomepageSearch";
import HomepageTrendingSearches from "../HomepageTrendingSearches/HomepageTrendingSearches";
import HomepageViewResumeDialog from "../HomepageViewResumeDialog/HomepageViewResumeDialog";
import HomepageWelcomeDialog from "../HomepageWelcomeDialog/HomepageWelcomeDialog";
import MobileHomepageSearch from "../MobileHomepageSearch/MobileHomepageSearch";

import {
  BannerHomepageWrapper,
  StyledCheckCircle,
  ToastContentContainer,
  ToastContentText,
  ToastStyled,
  ToastTitle,
  ToastTitleContainer,
} from "./styles";

function HomepageWrapper(props) {
  const [transparentNavbar, setTransparentNavbar] = useState(false);
  const [width, setWidth] = useState(0);
  const { userResume, setUserResume } = useHomepageResumeUploadState();
  const [toastBool, setToastBool] = useState(null);
  const [showWelcomeDialog, setShowWelcomeDialog] = useState(false);
  const inputFileRef = useRef(null);
  const user = getUser();
  const reduxUser = useSelector((state) => state.user?.user);
  const recentSearches = fetchRecentSearches();
  const router = useRouter();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  let urlParams;

  useEffect(() => {
    const emailHotJob = getItem("email-hot-job");

    if (emailHotJob) {
      props.updateShowSignInModalStatus(true);
    }

    // Trigger login modal for links like ?login=true&email=xxx when user is not logged in
    try {
      const isAuthenticated = checkAuthentication();
      const searchParams = new URLSearchParams(window.location.search);
      const loginParam = searchParams.get("login");
      const loginEmail = searchParams.get("email");

      if (!isAuthenticated && loginParam === "true" && loginEmail) {
        props.updateShowSignInModalStatus(true);
        props.updateSignInModalSignUpStatus(false);
      }
    } catch (e) {
      //
    }

    // Check for MRP sign-up in URL
    if (
      router.asPath.includes("referral_new_sign_up") &&
      !checkAuthentication()
    ) {
      const url = window.location.search;
      const urlParams = new URLSearchParams(url);
      const mrpParentID = urlParams.get("mrp_parent_id");
      const refereeEmail = urlParams.get("referee_email");

      store.getState().user.user.email = refereeEmail;
      props.updateShowSignInModalStatus(true);
      props.updateSignInModalSignUpStatus(true);

      if (mrpParentID?.length > 0 && refereeEmail?.length > 0) {
        Cookies.set("mrpId", mrpParentID, { expires: 7 });
      } else if (document.cookie.indexOf("mrpId") != -1) {
        //
      }
    }

    // Check for October Follower Growth Campaign sign-up and pass url params to redirected users
    if (router.asPath.includes("october_follower_growth_campaign")) {
      props.updateShowSignInModalStatus(true);
      props.updateSignInModalSignUpStatus(true);
      urlParams = new URLSearchParams(window.location.search);
    }

    // Redirect logged-in users or visitors with search to jobs list page
    if (user || recentSearches.length > 0) {
      if (router.asPath.includes("october_follower_growth_campaign")) {
        router.push(`/jobs/?${urlParams}`);
      }
    }

    // Compare once and add resize listener on "componentDidMount"
    window.addEventListener("resize", compareSize);

    if (!width) {
      setWidth(window.innerWidth);
    }

    setTransparentNavbar(true);

    // Remove resize listener again on "componentWillUnmount"
    return () => {
      window.removeEventListener("resize", compareSize);
    };
  }, []);

  const naikgajiUserid = reduxUser?.fromNaikgaji || user?.fromNaikgaji;
  const isLoggedIn = Boolean(reduxUser?.id || user?.id);
  const isNaikGajiUser = isLoggedIn && naikgajiUserid;

  useEffect(() => {
    if (typeof window === "undefined") return;
    const naikgajiOnboarding =
      localStorage.getItem("naikgajiOnboarding") === "true";
    if (isNaikGajiUser && naikgajiOnboarding) {
      setShowWelcomeDialog(true);
    }
  }, [isNaikGajiUser]);

  const compareSize = () => {
    setWidth(window.innerWidth);
  };

  const triggerToast = (bool, content) => {
    setToastBool(bool);

    const toastConfig = {
      icon: false,
      className: bool ? "Toast-success" : "Toast-error",
    };

    if (bool) {
      toast(toastUploadedResume(), toastConfig);
    } else {
      toast(content, toastConfig);
    }
  };

  useEffect(() => {
    if (
      localStorage.getItem("showCurrentSalaryDialogAfterJump") === "1" &&
      user?.id
    ) {
      const dontShow = localStorage.getItem(
        `currentSalaryDialogDontShow_${user?.id}`
      );
      if (!user?.currentSalary && !dontShow) {
        setTimeout(() => {
          dispatch(updateCurrentSalaryDialog(true));
          localStorage.removeItem("showCurrentSalaryDialogAfterJump");
        }, 500);
      } else {
        localStorage.removeItem("showCurrentSalaryDialogAfterJump");
      }
    }
  }, [dispatch, user]);

  function toastUploadedResume() {
    return (
      <Grid>
        <ToastTitleContainer>
          <StyledCheckCircle />
          <ToastTitle>{t("homepage.drop_resume_success_title")}</ToastTitle>
        </ToastTitleContainer>
        <ToastContentContainer>
          <ToastContentText>{t("homepage.drop_resume_success_message")}</ToastContentText>
        </ToastContentContainer>
      </Grid>
    );
  }

  const handleWelcomeClose = () => {
    if (typeof window !== "undefined") {
      localStorage.setItem("naikgajiOnboarding", "false");
    }
    setShowWelcomeDialog(false);
  };

  const handleWelcomeComplete = () => {
    if (typeof window !== "undefined") {
      localStorage.setItem("naikgajiOnboarding", "false");
      localStorage.setItem("trigger_profile_complete_sections", "1");
    }
    setShowWelcomeDialog(false);
    router.push("/profile");
  };

  return (
    <Fragment>
      <HomepageResumeUploadedDialog
        inputFileRef={inputFileRef}
        triggerToast={triggerToast}
        userResume={userResume}
        setUserResume={setUserResume}
      />
      <HomepageWelcomeDialog
        open={showWelcomeDialog}
        onClose={handleWelcomeClose}
        onComplete={handleWelcomeComplete}
      />
      <HomepageReplaceResumeDialog
        triggerToast={triggerToast}
        userResume={userResume}
        setUserResume={setUserResume}
      />
      <HomepageViewResumeDialog userResume={userResume} />
      <ToastStyled
        position="top-right"
        autoClose={2000}
        limit={2}
        pauseOnHover={false}
      />
      {props.showMobileSearch ? (
        <MobileHomepageSearch />
      ) : (
        <Fragment>
          <SharedNavbar2 page="user-landing-page" />
          <Toolbar />
          <BannerHomepageWrapper>
            <HomepageSearch
              inputFileRef={inputFileRef}
              triggerToast={triggerToast}
              userResume={userResume}
              setUserResume={setUserResume}
            />
            <HomepageTrendingSearches />
            <HomepageAds />
            <HomepageDiscoverCompanies />
          </BannerHomepageWrapper>
          {process.env.NEXT_PUBLIC_JSW_GEOLOCATION !== "sg" && (
            <SharedDownloadAppBanner />
          )}
        </Fragment>
      )}
    </Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    showMobileSearch: state.navbar.showMobileSearch,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateShowSignInModalStatus: bindActionCreators(
      updateShowSignInModalStatus,
      dispatch
    ),
    updateSignInText: bindActionCreators(updateSignInText, dispatch),
    updateSignUpText: bindActionCreators(updateSignUpText, dispatch),
    updateSignInModalSignUpStatus: bindActionCreators(
      updateSignInModalSignUpStatus,
      dispatch
    ),
    updateProfilePreviewDialog: bindActionCreators(
      updateProfilePreviewDialog,
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomepageWrapper);
